var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI_Platform",
    "data-name": "AI Platform"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.25,
    y: 43,
    width: 111,
    height: 37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.46,80H18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.25,43.79A8.8,8.8,0,0,1,18,35h93.42a8.8,8.8,0,0,1,8.79,8.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.25,
    y: 80,
    width: 12,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.25,
    y: 80,
    width: 12,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.25,
    y: 80,
    width: 87,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.25,
    y: 15,
    width: 55,
    height: 10,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.25,
    y1: 20,
    x2: 74.25,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.25,
    y1: 97,
    x2: 64.25,
    y2: 102
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.25,
    y1: 103,
    x2: 58.25,
    y2: 103
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 65.25,
    y1: 103,
    x2: 70.25,
    y2: 103
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.25,
    y1: 104,
    x2: 64.25,
    y2: 109
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.25,
    y1: 100,
    x2: 31.25,
    y2: 105
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.25,
    y1: 106,
    x2: 25.25,
    y2: 106
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.25,
    y1: 106,
    x2: 37.25,
    y2: 106
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.25,
    y1: 107,
    x2: 31.25,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 97.25,
    y1: 103,
    x2: 97.25,
    y2: 108
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.25,
    y1: 109,
    x2: 91.25,
    y2: 109
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 98.25,
    y1: 109,
    x2: 103.25,
    y2: 109
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 97.25,
    y1: 110,
    x2: 97.25,
    y2: 115
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPlatform);
export default __webpack_public_path__ + "static/media/ai_platform.2ef957a7d6199e7d74e725ee89586685.svg";
export { ForwardRef as ReactComponent };